export default "__VITE_ASSET__Bq33Lb4f__"